import { render, staticRenderFns } from "./MonthlyAssetStatuses.vue?vue&type=template&id=2baadece&scoped=true&"
import script from "./MonthlyAssetStatuses.vue?vue&type=script&lang=ts&"
export * from "./MonthlyAssetStatuses.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlyAssetStatuses.vue?vue&type=style&index=0&id=2baadece&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baadece",
  null
  
)

export default component.exports